module.exports = __webpack_public_path__ + "static/media/address-f.b51e03d2.svg";